import * as React from 'react'
import { getNsCodeByPath } from 'common/constants'
import { isEmptyObject } from 'common/utils/logic/object'

type Props = {}

class Nclicks extends React.Component<Props, {}> {
  componentDidMount() {
    if (window) window.addEventListener('click', this.handleClick)
  }

  componentWillUnmount() {
    if (window) window.removeEventListener('click', this.handleClick)
  }

  handleClick = (event: any) => {
    let targetElement = event.target || event.srcElement
    if (targetElement.nodeType === 3) targetElement = targetElement.parentNode
    if (targetElement.parentNode && targetElement.parentNode.nodeName === 'A') targetElement = targetElement.parentNode
    if (!this.hasNclickCodeClassName(targetElement)) {
      let checkCount = 0
      while (checkCount <= 4) {
        if (!this.hasNclickCodeClassName(targetElement) && targetElement.parentNode) {
          targetElement = targetElement.parentNode
        } else break
        checkCount += 1
      }
    }
    if (!this.hasNclickCodeClassName(targetElement)) return
    const classNames: string[] = targetElement.getAttribute('class').split(' ')
    for (const className of classNames) {
      if (className.startsWith('N=')) {
        const nclickImage = new Image()
        const nclickParam = this.getNclickParams(className)
        nclickImage.src = getClickCrUrl(makeNClickCode(nclickParam), event)
      }
    }
  }

  isHtmlElement(htmlElement: any) {
    if (htmlElement instanceof HTMLElement) {
      return true
    }

    return false
  }

  hasNclickCodeClassName = (htmlElement: any) => {
    try {
      if (htmlElement && htmlElement.getAttribute('class').includes('N=')) {
        return true
      }
    } catch (e) {}
    return false
  }

  getNclickParams = (nclickClassName: string): Params => {
    if (!nclickClassName) return null

    const nclickVal = nclickClassName.match(new RegExp('N[^=]*=([^ $]*)'))
    if (nclickVal && nclickVal.length) {
      const val = nclickVal[1]
      const a = val.match(new RegExp('a:([^(, )$]*)'))
      const i = val.match(new RegExp('i:([^(, )$]*)'))
      const r = val.match(new RegExp('r:([^(, )$]*)'))
      const g = val.match(new RegExp('g:([^ $]*)'))
      return {
        a: a && a.length ? a[1] : null,
        i: i && i.length ? i[1] : null,
        r: r && r.length && !isNaN(Number(r[1])) ? Number(r[1]) : null,
        g: g && g.length ? g[1] : null,
      }
    }
    return null
  }

  render() {
    const { children } = this.props
    return <>{children}</>
  }
}

export default Nclicks

export const getClickCrUrl = (nclickCode: string, event: any) => {
  const crTagUrl = []
  crTagUrl.push(window.location.protocol)
  crTagUrl.push('//cc.naver.com/cc?')
  crTagUrl.push(nclickCode)
  crTagUrl.push(`&bw=${window.innerWidth}`)
  try {
    if (event) {
      crTagUrl.push(`&px=${event.pageX}`)
      crTagUrl.push(`&py=${event.pageY}`)
      crTagUrl.push(`&sx=${event.x}`)
      crTagUrl.push(`&sy=${event.y}`)
    }
  } catch (e) {}
  crTagUrl.push('&m=0')
  crTagUrl.push(`&nsc=${getNsCodeByPath()}`)
  crTagUrl.push(`&u=${encodeURIComponent(window.location.href)}`)
  crTagUrl.push(`&time=${Date.now()}`)
  return crTagUrl.join('')
}

export const clickCr = (nclickCode: string, event: any) => {
  const nclickImage = new Image()
  nclickImage.src = getClickCrUrl(nclickCode, event)
}

interface Params {
  a: string
  i?: string
  r?: number
  g?: string
}

const makeNClickCode = (params: Params): string => {
  if (!params || isEmptyObject(params)) return null
  return Object.keys(params)
    .filter(key => params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&')
}

export const clickCrByParams = (params: Params, event?) => {
  const nClickImage = new Image()
  nClickImage.src = getClickCrUrl(makeNClickCode(params), event)
}
